<template>
  <div class="zijiay">
    <div
      class="zijiyouList"
      @click="detailpage(item)"
      v-for="item in zijiayouList"
      :key="item.id"
    >
      <div class="imgtext">
        <img :src="item.selfdri_the_image" alt="" />
         <span>{{item.selfdri_name}}</span>
      </div>
      <div class="text" v-if="textFlag"><p>{{item.sche_type}}</p><p>{{item.oneselftypes | filterOne}}</p> </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    zijiayouList:{
      type: Array,
      default(){
        return []
      }
    },
    //是否显示描述
    textFlag:{
      type: Boolean,
      default(){
        return false
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    detailpage(item) {
      this.$emit("detailpage", item);
    },
  },
  filters:{ //钩子
    filterOne(val){
      return val.substring(0, val.lastIndexOf('/'))
    },
  }
};
</script>
<style scoped>
.zijiay {
  margin: 0 4px;
}
.zijiay img {
  width: 100%;
  height: 180px;
}
.zijiay .imgtext{
  position: relative;
}
.zijiay .text{
  padding: 2px;
}
.zijiay .text p{
  font-size: 14px;
  display: inline-block;
}
.zijiay .text p:first-child{
  margin-right: 8%;
}
.zijiyouList {
  position: relative;
  margin-bottom: 16px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  overflow: hidden;
}
.zijiyouList span {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  padding: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  color: #fff;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
}
</style>